import type {
    CoverableChangesDTO,
    CoverableDTO,
    DiffDTO
} from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import type { OPCRowInformation } from '../../../../config/flavourConfig';
import type { TravelDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/tra';
import { getCoverableDiffsDTO, isChangeTypeAvailable } from '../../../../utils/opcChangesUtil';
import { AdjustItemKeys } from '../adjustDetails';

const LINE_PREFIX_TRA = 'TRA';
const AREA_DESTINATION_ATTRIBUTE_NAME = 'AreaDestination';

const getIndividualAndTravelAdjustDetailsConfig = (
    individual: TravelDTO,
    changes: DiffDTO[],
    isOpc: boolean
): OPCRowInformation[] => {
    const coverableId = individual.fixedId ?? '';
    const isAreaDestinationAvailable = isChangeTypeAvailable(
        { type: 'attribute', attributeFieldName: AREA_DESTINATION_ATTRIBUTE_NAME },
        changes
    );

    return [
        {
            key: AdjustItemKeys.TRA_AREA_DESTINATION,
            // Todo: Use hippo label when label id is define in document [Hippo TRA]
            name: 'Forsikringen gælder rejser i',
            fieldValue: individual.areaDestination,
            isAdjustableItem: true,
            labelType: 'normal',
            opcInfo: {
                changeType: 'attribut',
                productName:
                    individual.flavourName === 'Rejseforsikring'
                        ? 'top_tra_household'
                        : 'top_tra_individual',
                coverableId,
                attribute: 'traAreaOfDestination'
            },
            hidden: isOpc && !isAreaDestinationAvailable
        }
    ];
};

const getTravelAdjustDetailsConfig = (
    travel: CoverableDTO,
    isOpc: boolean,
    coverableChangesDTO: CoverableChangesDTO[]
): OPCRowInformation[] => {
    const changes = getCoverableDiffsDTO(
        coverableChangesDTO,
        LINE_PREFIX_TRA,
        travel.fixedId ?? ''
    );

    switch (travel.flavourName) {
        case 'Rejseforsikring':
        case 'Rejseforsikring til enkeltperson':
            return getIndividualAndTravelAdjustDetailsConfig(travel, changes, isOpc);
        default:
            throw new Error('Coverable is not travel flavour');
    }
};

export default getTravelAdjustDetailsConfig;
